import { render, staticRenderFns } from "./BalanceStatement-0.vue?vue&type=template&id=39f3e097"
import script from "./BalanceStatement-0.vue?vue&type=script&lang=js"
export * from "./BalanceStatement-0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports